import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMuteIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.0366 12.9581C14.6666 12.3281 15.7466 12.7781 15.7466 13.6681V16.5981C15.7466 18.3181 15.1266 19.6081 14.0166 20.2281C13.5666 20.4781 13.0666 20.5981 12.5466 20.5981C11.7466 20.5981 10.8866 20.3281 10.0066 19.7781L9.36656 19.3781C8.82656 19.0381 8.73656 18.2781 9.18656 17.8281L14.0366 12.9581Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M21.77 2.23281C21.47 1.93281 20.98 1.93281 20.68 2.23281L15.73 7.18281C15.67 5.58281 15.07 4.38281 14.01 3.79281C12.89 3.17281 11.46 3.33281 10 4.24281L7.09 6.06281C6.89 6.18281 6.66 6.25281 6.43 6.25281H5.5H5C2.58 6.25281 1.25 7.58281 1.25 10.0028L1.25 14.0028C1.25 16.4228 2.58 17.7528 5 17.7528H5.16L2.22 20.6928C1.92 20.9928 1.92 21.4828 2.22 21.7828C2.38 21.9228 2.57 22.0028 2.77 22.0028C2.97 22.0028 3.16 21.9228 3.31 21.7728L21.77 3.31281C22.08 3.01281 22.08 2.53281 21.77 2.23281Z",
		fill: "white"
	})]
});
export default SvgMuteIcon;
